import { Navigate, Outlet, useLocation, useParams } from "react-router-dom";

import { getHomePath, resolveLang } from "@/config/routes";
import { useAuthStore } from "@/stores/AuthStore";

/**
 * Route guard for public-only routes (login). Renders the matched child route
 * when the user is NOT authenticated, otherwise redirects authenticated users
 * away — to the page they originally tried to reach (stashed by
 * `ProtectedRoute`), falling back to the home page.
 */
const PublicRoute = () => {
  const location = useLocation();
  const { lang } = useParams<{ lang: string }>();
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);

  if (isAuthenticated) {
    const from = (location.state as { from?: { pathname?: string } } | null)
      ?.from?.pathname;
    return <Navigate to={from ?? getHomePath(resolveLang(lang))} replace />;
  }

  return <Outlet />;
};

export default PublicRoute;
